import { CircularProgress } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { green } from '@material-ui/core/colors';

const useStyles = makeStyles((theme) => ({
    overlayProgress: {
      color: theme.palette.secondary.light,
      position: 'absolute',
      top: '50%',
      left: '50%',
      marginTop: size => -size / 2,
      marginLeft: size => -size / 2,
    },
  }));

function ProgressOverlay(props) {

  var size = 40;
  if (props.size) {
    size = props.size;
  }

  const classes = useStyles(size);

  return <CircularProgress size={size} className={classes.overlayProgress} />;
}

export default ProgressOverlay;
